// extracted by mini-css-extract-plugin
export default {"tagList":"styles-module__tagList__src-labstep-web-components-Tag-List-_EA_XP"};